import api from "./client";
// --- Kategoriler ---
export async function getCategories() {
    const res = await api.get("/admin/blog/categories");
    return res.data;
}
export async function createCategory(data) {
    const res = await api.post("/admin/blog/categories", data);
    return res.data;
}
export async function updateCategory(id, data) {
    const res = await api.put(`/admin/blog/categories/${id}`, data);
    return res.data;
}
export async function deleteCategory(id) {
    await api.delete(`/admin/blog/categories/${id}`);
}
// --- Postlar ---
export async function getPosts(params = {}) {
    const res = await api.get("/admin/blog/posts", { params });
    return res.data;
}
export async function getPost(id) {
    const res = await api.get(`/admin/blog/posts/${id}`);
    return res.data;
}
export async function createPost(data) {
    const res = await api.post("/admin/blog/posts", data);
    return res.data;
}
export async function updatePost(id, data) {
    const res = await api.put(`/admin/blog/posts/${id}`, data);
    return res.data;
}
export async function deletePost(id) {
    await api.delete(`/admin/blog/posts/${id}`);
}
